export class ChangePasswordModel {
    currentPassword: string;
    newPassword: string;
    username: string;
    token: string;
    email: string;
    type: string;
}
